import { SignUpState } from '../../types';
import { MutationTree } from 'vuex';

const mutations: MutationTree<SignUpState> = {
  setName(state: SignUpState, name): void {
    state.name = name;
  },
  setEmail(state: SignUpState, email): void {
    state.email = email;
  },
  setPhone(state: SignUpState, phone): void {
    state.phone = phone;
  },
  setOrganization(state: SignUpState, organization): void {
    state.organization = organization;
  },
  setBusinessType(state: SignUpState, businessType): void {
    state.businessType = businessType;
  },
};

export default mutations;
